/**
 * @author Indeform Ltd
 * @copyright Copyright 2019, Indeform Ltd
 * @version 20200514
 * @description Main (body based) Component.
 */


import Component from "../core/component";


class Main extends Component {

    constructor(ui) {
        super(ui,
            Component.ELMID_BODY,
            ['click'],
            {
                elmDestination: 'contentWrapper',
                elmReceiveConsultationInvite: 'id_receive_consult_invitation_mail',
                loginFormId: 'formLogin',
            }
        );
    }


    on_toggleConsultant(data, e) {
        if (e.target.checked) {
            this.on_modalOpen(data, e);
        } else {
            let receiveConsultationInvite = document.getElementById(
                this.params.elmReceiveConsultationInvite);
            
            if (receiveConsultationInvite) {
                let parentNode = receiveConsultationInvite.parentNode.parentNode.parentNode;

                receiveConsultationInvite.setAttribute('hidden', '');
                parentNode.classList.add('hidden');
            }
        }
    }


    on_modalOpen(data, e) {
        if (data.className === undefined || this.ui[data.className] === undefined) return;

        let modal = this.ui[data.className];

        if (modal.isAttachedToElement()) modal.open(data);
    }


    on_serviceRedirect(data, e) {
        if (data.url) {
            window.location.href = data.url;
        }
    }
}

export { Main }
export default Main
